module.exports = __webpack_public_path__ + "img/user.e5d5f743.svg";